import { TranslationSchema } from './en';

// Chinese translations
export const zh: TranslationSchema = {
  // Navigation
  navigation: {
    menu: {
      home: '首页',
      ourStory: '我们的故事',
      services: '服务',
      howItWorks: '流程',
    },
    cta: {
      consultation: '预约免费咨询',
      languageSwitch: '中文',
    },
  },
  
  // Hero Section
  hero: {
    title: {
      main: '美国一站式咨询与生活管家服务',
    },
    subtitle: {
      services: '学校 · 法律支持 · 住房 · 商业 · 饮品咨询 · 高端管家',
    },
    cta: {
      consultation: '预约15分钟免费咨询',
      viewServices: '查看所有服务',
    },
  },
  
  // Footer
  footer: {
    brand: {
      title: 'Auren Stratus LLC',
      description: '专业的美国咨询与生活管理服务',
      tagline: '您在美国值得信赖的合作伙伴',
    },
    sections: {
      quickLinks: {
        title: '快速链接',
        subtitle: '导航',
        services: '服务',
        pricing: '定价',
        about: '关于我们',
        faq: '常见问题',
        contact: '联系我们',
      },
      contact: {
        title: '联系方式',
        subtitle: '与我们联系',
        email: 'info@aurenstratus.com',
        location: '美国',
      },
      wechat: {
        title: '微信',
        subtitle: '与我们联系',
        scan: '扫码添加微信',
      },
    },
    legal: {
      copyright: '© 2025 Auren Stratus LLC. 版权所有。',
      disclaimer: '法律声明：Auren Stratus LLC 提供咨询和协调服务。我们不是律师事务所、房地产机构或持牌医疗服务提供商。所有专业服务均通过我们的持牌专业人士网络提供。',
    },
  },
  
  // Customer Personas Section
  customerPersonas: {
    section: {
      title: '我们服务的客户',
      subtitle: '为每种需求量身定制解决方案',
    },
    personas: {
      families: {
        title: '在美华人家庭',
        subtitle: '家庭支持服务',
        description: '学校咨询、霸凌沟通支持、搬迁协助、全方位家庭支持服务',
      },
      entrepreneurs: {
        title: '华人企业家',
        subtitle: '商业发展',
        description: '商业进入策略、饮品产品开发、执行和运营支持',
      },
      elite: {
        title: '精英及高净值人士',
        subtitle: '高端管家',
        description: '私人管家服务、专属生活方式管理、个性化高端支持',
      },
    },
  },

  // Services Grid Section
  servicesGrid: {
    section: {
      title: '我们的服务',
      subtitle: '为您在美国的旅程提供全方位解决方案',
    },
    services: {
      education: {
        title: '教育咨询',
        subtitle: '学业成功',
        description: '学校选择、入学支持和学业成功策略',
      },
      legal: {
        title: '法律支持协调',
        subtitle: '专业网络',
        description: '为您的具体需求联系值得信赖的法律专业人士',
      },
      realEstate: {
        title: '房地产与搬迁',
        subtitle: '找房服务',
        description: '寻找您的理想家园并提供无缝搬迁协助',
      },
      homeManagement: {
        title: '家庭管理',
        subtitle: '生活方式协调',
        description: '全方位家庭管理和生活方式协调',
      },
      spiritual: {
        title: '精神健康',
        subtitle: '全面支持',
        description: '全面的健康支持和心理健康资源',
      },
      business: {
        title: '商业咨询',
        subtitle: '战略规划',
        description: '战略业务规划和市场准入指导',
      },
      beverage: {
        title: '饮品开发',
        subtitle: '产品创新',
        description: '饮品业务的产品开发和市场策略',
      },
      elite: {
        title: '高端管家',
        subtitle: '高级服务',
        description: '专属个人助理和高端生活方式服务',
      },
    },
    cta: {
      learnMore: '了解更多',
    },
  },

  // Workflow Section
  workflow: {
    section: {
      title: '工作流程',
      subtitle: '开始的简单步骤',
    },
    steps: {
      submit: {
        title: '提交需求并预约',
        subtitle: '开始',
        description: '填写我们的表格并安排您的免费15分钟咨询电话',
      },
      consultant: {
        title: '顾问建议',
        subtitle: '专家指导',
        description: '接受我们专家的初步指导和个性化建议',
      },
      payment: {
        title: '付款详情',
        subtitle: '下一步',
        description: '获取包含服务详情和安全付款选项的后续邮件',
      },
      support: {
        title: '持续支持',
        subtitle: '持续关怀',
        description: '继续付费会话或全方位基于项目的协助',
      },
    },
  },

  // Testimonials Section
  testimonials: {
    section: {
      title: '客户推荐',
      subtitle: '客户评价',
      tagline: '受到数十个华人家庭和企业家的信赖',
    },
    clients: {
      sarahLi: {
        name: '李女士',
        role: '企业主',
        location: '加利福尼亚州',
        quote: 'Auren Stratus 帮助我们全家在美国顺利安顿下来。从为孩子选择合适的学校到管理家庭生活的方方面面，他们在每一步都提供了专业指导。',
      },
      davidZhang: {
        name: '张先生',
        role: '创始人兼首席执行官',
        location: '纽约州',
        quote: '他们的饮品开发咨询非常专业。从产品配方到市场策略，他们提供了全方位支持，帮助我的品牌成功进入美国市场。',
      },
      jenniferWang: {
        name: '王女士',
        role: '私人投资者',
        location: '西雅图',
        quote: '高端管家服务让我的生活安排得完美有序。无论是商务安排还是个人事务，都有专业团队在背后支持我。真正的无忧生活。',
      },
    },
  },

  // CTA Banner Section
  ctaBanner: {
    title: '立即获取美国专业帮助',
    subtitle: '为您的美国之旅提供专业支持',
    description: '无论您需要教育咨询、商业支持还是生活方式管理服务，我们的专业团队都准备为您提供量身定制的解决方案，满足您的独特需求。',
    cta: '预约15分钟免费咨询',
  },

  // Our Story Page
  ourStory: {
    hero: {
      title: '我们的故事',
      description: '我们创立 Auren Stratus LLC 是因为在美国搬家、学习和建立生活不应该如此复杂和令人困扰。',
    },
    inspiration: {
      team: '我们团队中的许多人本身就是移民、父母和创业者。我们了解文件工作、不确定性和在新国家生活的情感压力。',
      mission: '我们将个人经历转化为使命——让您在美国的旅程变得自信、明智并得到支持。',
    },
    problem: {
      title: '我们解决的问题',
      tagline: '您不必独自面对这一切。',
      challenges: {
        families: {
          title: '家庭',
          description: '在学校选择和沟通方面遇到困难',
        },
        founders: {
          title: '创业者',
          description: '面临进入美国市场的复杂性',
        },
        highNetWorth: {
          title: '高净值人士',
          description: '需要谨慎可靠的支持',
        },
      },
    },
    differences: {
      title: '我们的与众不同之处',
      items: {
        bilingual: {
          title: '双语团队',
          description: '具有美国和中国背景，深度了解文化差异',
        },
        execution: {
          title: '真正执行',
          description: '不仅仅是建议——我们帮助您把事情做好',
        },
        tailored: {
          title: '量身定制的指导',
          description: '为您的真实需求量身设计的定制支持',
        },
        relationship: {
          title: '关系驱动',
          description: '保密、关怀，并致力于您的成功',
        },
      },
    },
    team: {
      title: '认识我们的团队',
      subtitle: '致力于您成功的经验丰富的专业人士',
      members: {
        education: {
          role: '教育策略顾问',
          expertise: '10年以上支持家庭适应美国学校转换的经验',
        },
        legal: {
          role: '法律协调专家',
          expertise: '移民和跨境法律支持专家',
        },
        business: {
          role: '商业发展顾问',
          expertise: '帮助50多个中国企业家进入美国市场',
        },
        concierge: {
          role: '管家服务总监',
          expertise: '为高净值客户提供高端生活方式管理',
        },
      },
    },
    promise: {
      quote: '我们支持您的生活、梦想和里程碑——用我们初来乍到时希望得到的关怀。',
    },
    cta: {
      title: '让我们一起走这段旅程。',
      button: '预约15分钟免费咨询',
    },
  },

  // Services Overview Page
  servicesOverview: {
    hero: {
      title: '我们的服务',
      description: '为在美华人家庭和创业者提供一站式咨询和安居支持。',
    },
    services: {
      schoolFamily: {
        title: '学校及家庭支持',
        description: '自信地导航美国教育系统。从学校选择到家长教师沟通，我们帮助您的家庭在学术和社交方面蓬勃发展。',
        pricing: '$300–$3,500',
      },
      legal: {
        title: '法律支持协调',
        description: '为签证、移民和合规事务联系值得信赖的法律专业人士。我们协调流程，让您专注于最重要的事情。',
        pricing: '$80–$150/小时',
      },
      realEstate: {
        title: '房地产与搬迁',
        description: '在合适的社区找到您理想的家。我们从房产搜索到入住协调和当地导向提供端到端支持。',
        pricing: '$300–$2,000',
      },
      homeManagement: {
        title: '家庭管理',
        description: '通过值得信赖的家庭服务协调简化您的日常生活。从承包商到家政服务，我们确保质量和安心。',
        pricing: '$199–$799/月或$99–$299/次',
      },
      spiritual: {
        title: '精神健康',
        description: '在适应美国生活时找到社区和精神支持。我们为您联系基于信仰的资源和文化项目。',
        pricing: '$250–$2,500',
      },
      business: {
        title: '商业咨询',
        description: '通过战略指导启动和发展您的美国业务。从市场进入到运营，我们帮助您导航美国商业环境。',
        pricing: '$300–$1,500+',
      },
      beverage: {
        title: '饮品开发咨询',
        description: '通过配方、合规、品牌和分销方面的专业指导，将您的饮品概念推向美国市场。',
        pricing: '从$3,000+起',
      },
      elite: {
        title: '高端管家服务',
        description: '体验生活各个方面的白手套个人助理服务。从旅行规划到独家活动准入，我们处理所有细节。',
        pricing: '$12,000–$75,000/年',
      },
    },
    pricing: {
      label: '价格：',
    },
    cta: {
      learnMore: '了解更多',
      title: '不确定哪项服务适合您的情况？',
      description: '从免费15分钟咨询开始。我们会倾听您的需求并推荐最佳的前进路径。',
      button: '预约15分钟免费电话',
    },
  },

  // How It Works Page
  howItWorks: {
    hero: {
      title: '工作流程',
      description: '我们让您在美国的旅程变得简单。一个团队帮助您导航学校、生活、商业和机会——一切都从免费的15分钟电话开始。',
    },
    process: {
      title: '我们的4步流程',
      subtitle: '简单 → 透明 → 双语 → 真正的执行，不仅仅是建议。',
      steps: {
        booking: {
          title: '预约您的免费电话',
          description: '您选择一个服务类别并简短描述您的需求。我们进行15分钟的电话会议来了解您的目标。',
        },
        recommendation: {
          title: '接收个性化建议',
          description: '根据您的情况，我们评估您实际需要什么以及成功是什么样子——包括明确的范围和定价选项。',
        },
        payment: {
          title: '继续付费服务',
          description: '如果您决定继续，我们会通过电子邮件发送推荐咨询计划的安全付款链接。免费电话后无需承诺。',
        },
        execution: {
          title: '执行和持续支持',
          description: '我们安排更深入的会议或管家式行动来帮助您实施——无论是学校支持、搬迁、商业策略、饮品开发还是私人管家需求。',
        },
      },
    },
    expectations: {
      title: '您可以期待什么',
      items: {
        guidance: {
          title: '明确指导，无推销压力',
          description: '我们专注于您需要什么，而不是我们想要销售什么。',
        },
        pricing: {
          title: '基于范围的透明定价',
          description: '您在承诺之前就会确切知道您要为什么付费。',
        },
        bilingual: {
          title: '双语文化对接',
          description: '我们深度了解美国和中国商业文化。',
        },
        confidential: {
          title: '保密、高接触执行支持',
          description: '您的隐私受到保护，并提供个性化的亲身协助。',
        },
      },
    },
    faq: {
      title: '常见问题',
      questions: {
        freeCall: {
          question: '免费电话真的免费吗？',
          answer: '是的。15分钟咨询是完全免费的。除非您决定在咨询后继续付费服务，否则没有承诺也不需要付款。',
        },
        oneTime: {
          question: '如果我只需要一次帮助，可以就此停止吗？',
          answer: '可以。您可以在免费电话后选择单次付费会议。没有长期合同——您完全控制您预约的内容。',
        },
        legal: {
          question: '你们提供法律建议吗？',
          answer: '不。我们不提供法律建议、法律代表或律师服务。我们可以帮助您：组织案件相关信息、指导沟通物流、在需要时与持牌律师协调。（重要：最终的法律判断或法律指导必须来自持牌律师。）',
        },
        cost: {
          question: '我如何知道最终费用？',
          answer: '免费电话后，我们提供明确的服务建议，包括：针对您情况的范围、透明定价（小时、套餐或基于项目）、发送到您邮箱的安全付款链接。您在任何事情继续之前都要批准——没有意外。',
        },
      },
    },
    finalCta: {
      title: '准备在美国获得真正的帮助了吗？',
      button: '预约15分钟免费电话',
    },
  },

  // Individual Service Pages
  services: {
    // School & Family Support Page
    schoolFamily: {
      hero: {
        title: '学校及家庭支持',
        description: '为学校选择、沟通和家庭在美国的成功提供专业指导。',
        subtitle: '以充分的文化理解为在美华人家庭服务。',
        cta: '预约15分钟免费咨询',
      },
      whatWeHelp: {
        title: '我们提供的帮助',
        subtitle: '明确、舒缓的支持，与您家庭的真实需求保持一致。',
        services: {
          enrollment: {
            title: '学校选择和入学指导',
            description: '私立学校或公立学校策略',
          },
          communication: {
            title: '与教师和学校管理人员的沟通',
            description: '自信地进行对话',
          },
          bullying: {
            title: '霸凌/行为问题支持',
            description: '有效地为您的孩子辩护',
          },
          iep: {
            title: 'IEP/504计划协调',
            description: '仅提供非法律指导',
          },
          transition: {
            title: '搬迁后的家庭过渡支持',
            description: '在您的新社区安顿下来',
          },
          coaching: {
            title: '导航美国学校系统的家长指导',
            description: '在育儿路程中建立信心',
          },
        },
      },
      howItWorks: {
        title: '工作流程',
        steps: {
          call: {
            title: '免费15分钟电话',
            description: '告诉我们您孩子的情况和目标。',
          },
          plan: {
            title: '个性化计划',
            description: '我们推荐正确的学校路径和支持方法。',
          },
          sessions: {
            title: '付费后续会议',
            description: '继续进行沟通、文书工作、指导或规划。',
          },
          results: {
            title: '进展和成果',
            description: '我们在重要的学校时刻与您同在。',
          },
        },
      },
      pricing: {
        title: '简单透明的定价',
        description: '价格从每15分钟50美元开始。',
        details: '您可以选择所需的会议次数——您的总额会自动更新。除了您预约的内容外，无需承诺。',
        followUp: '如果您后来决定继续，我们将根据您的独特目标提供量身定制的提案，包含明确的范围和报价。',
        cta: '预约您的会议',
      },
      whyChoose: {
        title: '家庭选择我们的原因',
        highlights: {
          bilingual: '美国教育和家庭支持的双语专家',
          cultural: '理解中国文化和期望',
          practical: '带来真实结果的实用指导',
          confidential: '保密、友好和支持性的伙伴关系',
        },
      },
      faq: {
        title: '常见问题',
        questions: {
          guarantee: {
            question: '您能保证学校录取吗？',
            answer: '我们不能保证结果，但我们通过准备和指导最大化您的机会。',
          },
          legal: {
            question: '你们提供法律建议吗？',
            answer: '不。我们帮助协调IEP/504和学校程序，但法律意见必须来自律师。',
          },
          online: {
            question: '我们可以完全在线完成吗？',
            answer: '可以。我们为全美国和国际的家庭提供支持。',
          },
          preparation: {
            question: '我应该如何为免费电话做准备？',
            answer: '请带上您孩子的年龄、年级水平、当前挑战和学校目标。',
          },
        },
      },
      finalCta: {
        title: '让我们帮助您的孩子在美国取得成功。',
        button: '预约15分钟免费咨询',
      },
    },

    // Business Consulting Page
    businessConsulting: {
      hero: {
        title: '商业咨询与美国市场进入',
        description: '从概念到执行——帮助中国创始人在美国取得成功。',
        cta: '预约15分钟免费咨询',
      },
      whatWeHelp: {
        title: '我们提供的帮助',
        subtitle: '从概念到执行的战略指导。',
        services: {
          strategy: {
            title: '美国市场商业策略',
            description: '导航美国商业环境',
          },
          planning: {
            title: '行动规划和运营指导',
            description: '将策略转化为可执行的步骤',
          },
          vendor: {
            title: '供应商协调和执行跟进',
            description: '管理关系和可交付成果',
          },
          networking: {
            title: '社区和本地资源网络',
            description: '连接合适的人员和资源',
          },
          setup: {
            title: '公司设立支持（非法律）',
            description: '通过成立和运营提供指导',
          },
        },
      },
      howItWorks: {
        title: '工作流程',
        steps: {
          call: {
            title: '免费15分钟电话',
            description: '分享您的商业愿景和当前阶段。',
          },
          plan: {
            title: '个性化计划',
            description: '我们推荐正确的策略和方法。',
          },
          sessions: {
            title: '付费后续会议',
            description: '继续进行咨询、规划和协调。',
          },
          results: {
            title: '进展和成果',
            description: '通过持续支持执行和成长。',
          },
        },
      },
      pricing: {
        title: '简单透明的定价',
        description: '价格从每15分钟50美元开始。',
        details: '您可以选择所需的会议次数——您的总额会自动更新。除了您预约的内容外，无需承诺。',
        followUp: '如果您后来决定继续，我们将根据您的独特目标提供量身定制的提案，包含明确的范围和报价。',
        cta: '预约您的会议',
      },
      whyChoose: {
        title: '选择我们的原因',
        highlights: {
          context: '了解美国和中国的商业环境',
          execution: '专注执行的支持',
          tailored: '针对您真实阶段的量身定制指导',
          discreet: '谨慎处理敏感企业',
        },
      },
      faq: {
        title: '常见问题',
        questions: {
          legal: {
            question: '你们提供法律或会计建议吗？',
            answer: '我们不是法律或会计顾问。我们提供商业策略和运营指导，可以为您联系法律和财务事务的持牌专业人士。',
          },
          confidential: {
            question: '一切都保密吗？',
            answer: '是的。始终保持完全保密。适当时我们也可以签署保密协议。',
          },
          remote: {
            question: '您可以远程为我工作吗？',
            answer: '完全可以。提供远程优先支持，有益时进行面对面会议。',
          },
          industries: {
            question: '你们与哪些行业合作？',
            answer: '我们与各个行业合作，在市场进入、产品开发和服务型业务方面实力特别强。',
          },
        },
      },
      finalCta: {
        title: '与值得信赖的合作伙伴建立您的业务。',
        button: '预约15分钟免费咨询',
      },
    },

    // Legal Support Coordination Page
    legalSupport: {
      hero: {
        title: '法律支持协调',
        description: '为您的具体移民和法律需求联系值得信赖的法律专业人士。',
        subtitle: '签证、移民和合规事务的专业协调。',
        cta: '预约15分钟免费咨询',
      },
      whatWeHelp: {
        title: '我们提供的帮助',
        subtitle: '为您在美国的旅程提供专业的法律协调和指导。',
        services: {
          visa: {
            title: '签证和移民协调',
            description: '联系合格的移民律师',
          },
          compliance: {
            title: '法律合规指导',
            description: '自信地导航美国法律要求',
          },
          documentation: {
            title: '文件准备支持',
            description: '组织和准备法律文件',
          },
          consultation: {
            title: '法律咨询协调',
            description: '安排和协调与法律专业人士的会面',
          },
          representation: {
            title: '法律代理协调',
            description: '为您的案件联系专业律师',
          },
          ongoing: {
            title: '持续法律事务支持',
            description: '在整个法律过程中持续协调',
          },
        },
      },
      howItWorks: {
        title: '工作流程',
        steps: {
          call: {
            title: '免费15分钟电话',
            description: '分享您的法律需求和当前情况。',
          },
          plan: {
            title: '专业匹配',
            description: '我们为您联系合格的法律专业人士。',
          },
          sessions: {
            title: '协调支持',
            description: '我们帮助协调沟通和流程。',
          },
          results: {
            title: '法律进展',
            description: '通过专业支持实现您的法律目标。',
          },
        },
      },
      pricing: {
        title: '简单透明的定价',
        description: '法律协调从每小时80-150美元开始。',
        details: '我们仅提供协调服务 - 法律费用是分开的，直接支付给律师。',
        followUp: '我们将为您联系合格的法律专业人士，并协调整个过程，让您安心。',
        cta: '获取法律协调',
      },
      whyChoose: {
        title: '为什么选择我们的法律协调',
        highlights: {
          network: '值得信赖的合格法律专业人士网络',
          bilingual: '在整个法律过程中提供双语支持',
          coordination: '全面协调和沟通管理',
          peace: '专业监督带来的安心',
        },
      },
      faq: {
        title: '常见问题',
        questions: {
          legal: {
            question: '你们提供法律建议吗？',
            answer: '不。我们仅提供协调服务。所有法律建议和代理都来自我们网络中的持牌律师。',
          },
          fees: {
            question: '法律费用如何运作？',
            answer: '您向我们支付协调费用，直接向律师支付法律费用。我们为两者都提供透明定价。',
          },
          selection: {
            question: '您如何选择律师？',
            answer: '我们与经过预先审查、合格的律师合作，他们专门为中国客户处理移民和商业法。',
          },
          support: {
            question: '您在过程中提供什么支持？',
            answer: '我们协调所有沟通，帮助准备文件，并确保您的法律事务过程顺利。',
          },
        },
      },
      finalCta: {
        title: '立即获得专业法律协调。',
        button: '预约15分钟免费咨询',
      },
    },

    // Real Estate & Relocation Page
    realEstate: {
      hero: {
        title: '房地产与搬迁支持',
        description: '在美国找到您的完美家园并提供无缝搬迁协助。',
        subtitle: '为您的家庭提供完整的找房和搬迁支持。',
        cta: '预约15分钟免费咨询',
      },
      whatWeHelp: {
        title: '我们提供的帮助',
        subtitle: '为您的住房和搬迁需求提供端到端支持。',
        services: {
          search: {
            title: '房屋搜索和社区选择',
            description: '为您的家庭找到完美的位置',
          },
          coordination: {
            title: '房地产经纪人协调',
            description: '联系值得信赖的当地房地产专业人士',
          },
          inspection: {
            title: '房屋检查和评估支持',
            description: '自信地导航购房流程',
          },
          moving: {
            title: '搬家和物流协调',
            description: '无缝搬迁规划和执行',
          },
          schools: {
            title: '学区研究和入学',
            description: '确保您的孩子能够接受优质教育',
          },
          community: {
            title: '社区融入支持',
            description: '连接当地资源和社区',
          },
        },
      },
      howItWorks: {
        title: '工作流程',
        steps: {
          call: {
            title: '免费15分钟电话',
            description: '讨论您的住房需求和搬迁时间表。',
          },
          plan: {
            title: '定制搜索计划',
            description: '我们为您制定有针对性的房屋搜索策略。',
          },
          sessions: {
            title: '找房支持',
            description: '在整个房屋搜索过程中提供持续支持。',
          },
          results: {
            title: '准备入住',
            description: '完整的搬迁支持，直到您安顿下来。',
          },
        },
      },
      pricing: {
        title: '简单透明的定价',
        description: '根据范围，搬迁支持从300-2,000美元起。',
        details: '定价根据地点、时间表和所需支持水平而有所不同。',
        followUp: '我们从初步搜索到成功搬迁提供全面支持。',
        cta: '开始您的找房之旅',
      },
      whyChoose: {
        title: '为什么选择我们的搬迁支持',
        highlights: {
          local: '在适合家庭的社区的当地专业知识',
          schools: '对学区和教育选择的深度了解',
          cultural: '理解中国家庭的住房偏好',
          support: '从搜索到安居的全方位服务支持',
        },
      },
      faq: {
        title: '常见问题',
        questions: {
          agent: {
            question: '您与特定的房地产经纪人合作吗？',
            answer: '我们与一个值得信赖的经纪人网络合作，他们理解搬迁到美国的中国家庭的需求。',
          },
          areas: {
            question: '您覆盖哪些地区？',
            answer: '我们提供全国范围的支持，在拥有强大学区的主要都市区域具有特别的专业知识。',
          },
          timeline: {
            question: '这个过程需要多长时间？',
            answer: '时间表根据市场条件和您的要求而有所不同，通常完整搬迁需要2-6个月。',
          },
          remote: {
            question: '如果我还在中国，您能帮助吗？',
            answer: '是的，我们提供全面的远程支持，包括虚拟看房、市场研究和搬迁规划。',
          },
        },
      },
      finalCta: {
        title: '在美国找到您的完美家园。',
        button: '预约15分钟免费咨询',
      },
    },

    // Home Management Page
    homeManagement: {
      hero: {
        title: '家庭管理服务',
        description: '为忙碌家庭提供全方位家庭管理和生活方式协调。',
        subtitle: '值得信赖的家庭服务协调和质量保证。',
        cta: '预约15分钟免费咨询',
      },
      whatWeHelp: {
        title: '我们提供的帮助',
        subtitle: '专业协调您所有的家庭需求。',
        services: {
          maintenance: {
            title: '家庭维护和维修协调',
            description: '值得信赖的承包商和优质服务管理',
          },
          cleaning: {
            title: '家政和清洁服务',
            description: '定期和深度清洁服务协调',
          },
          landscaping: {
            title: '景观设计和户外维护',
            description: '美丽且维护良好的户外空间',
          },
          security: {
            title: '家庭安全系统管理',
            description: '安装和监控协调',
          },
          utilities: {
            title: '公用事业设置和管理',
            description: '无缝公用事业协调和账单管理',
          },
          seasonal: {
            title: '季节性家庭准备',
            description: '过冬准备、夏季准备和季节性维护',
          },
        },
      },
      howItWorks: {
        title: '工作流程',
        steps: {
          call: {
            title: '免费15分钟电话',
            description: '讨论您的家庭管理需求和偏好。',
          },
          plan: {
            title: '服务计划制定',
            description: '我们设计定制的家庭管理计划。',
          },
          sessions: {
            title: '持续协调',
            description: '定期服务协调和质量监控。',
          },
          results: {
            title: '无忧生活',
            description: '享受您的家，让我们处理管理工作。',
          },
        },
      },
      pricing: {
        title: '简单透明的定价',
        description: '家庭管理从199-799美元/月或99-299美元/次起。',
        details: '定价基于服务频率和家庭管理需求范围。',
        followUp: '月度计划为持续家庭管理协调提供最佳价值。',
        cta: '开始家庭管理',
      },
      whyChoose: {
        title: '为什么选择我们的家庭管理',
        highlights: {
          vetted: '经过预先筛选的可信服务专业人士',
          quality: '质量保证和服务监控',
          bilingual: '双语协调和沟通',
          peace: '为忙碌家庭提供完全安心',
        },
      },
      faq: {
        title: '常见问题',
        questions: {
          services: {
            question: '您协调哪些服务？',
            answer: '我们协调所有家庭服务，包括清洁、维护、景观设计、安全和公用事业管理。',
          },
          emergency: {
            question: '您处理紧急维修吗？',
            answer: '是的，我们为紧急家庭维修和问题提供24/7紧急协调。',
          },
          staff: {
            question: '您如何选择服务提供商？',
            answer: '所有服务提供商都经过预先筛选，有保险，并有其他客户的优秀推荐。',
          },
          flexibility: {
            question: '我可以根据需要调整服务吗？',
            answer: '当然可以。您可以根据不断变化的需求和偏好随时调整您的服务计划。',
          },
        },
      },
      finalCta: {
        title: '通过专业家庭管理简化您的生活。',
        button: '预约15分钟免费咨询',
      },
    },

    // Spiritual Wellness Page
    spiritual: {
      hero: {
        title: '精神健康支持',
        description: '在您适应美国生活时找到社区、基于信仰的支持和精神健康资源。',
        subtitle: '全面健康和精神社区连接。',
        cta: '预约15分钟免费咨询',
      },
      whatWeHelp: {
        title: '我们提供的帮助',
        subtitle: '为您的旅程提供全面的精神和健康支持。',
        services: {
          community: {
            title: '信仰社区连接',
            description: '找到欢迎的精神社区和会众',
          },
          counseling: {
            title: '精神咨询协调',
            description: '联系合格的精神咨询师和顾问',
          },
          wellness: {
            title: '心理健康和健康资源',
            description: '心理和情感健康的全面方法',
          },
          cultural: {
            title: '文化和精神适应支持',
            description: '在保持信仰的同时导航文化差异',
          },
          programs: {
            title: '宗教教育和项目',
            description: '为儿童和家庭精神成长寻找项目',
          },
          ceremonies: {
            title: '宗教仪式协调',
            description: '为重要的精神里程碑和仪式提供支持',
          },
        },
      },
      howItWorks: {
        title: '工作流程',
        steps: {
          call: {
            title: '免费15分钟电话',
            description: '与我们分享您的精神和健康需求。',
          },
          plan: {
            title: '社区匹配',
            description: '我们帮助您找到合适的精神社区和资源。',
          },
          sessions: {
            title: '持续支持',
            description: '在您的精神旅程中持续指导。',
          },
          results: {
            title: '精神健康',
            description: '实现精神平衡和社区连接。',
          },
        },
      },
      pricing: {
        title: '简单透明的定价',
        description: '根据需求，精神健康支持从250-2,500美元起。',
        details: '定价根据支持水平和具体精神健康要求而有所不同。',
        followUp: '我们为您在美国的精神旅程提供敏感和尊重的支持。',
        cta: '开始您的精神之旅',
      },
      whyChoose: {
        title: '为什么选择我们的精神支持',
        highlights: {
          respectful: '对所有信仰传统和信念的尊重方法',
          community: '强大的精神社区和领袖网络',
          holistic: '精神和心理健康的全面方法',
          cultural: '理解文化和精神适应挑战',
        },
      },
      faq: {
        title: '常见问题',
        questions: {
          denominations: {
            question: '您与特定宗教合作吗？',
            answer: '我们支持所有信仰背景的人，包括基督教、佛教、道教和世俗精神实践。',
          },
          counseling: {
            question: '您提供精神咨询吗？',
            answer: '我们与合格的精神咨询师和牧师协调，但不直接提供咨询服务。',
          },
          children: {
            question: '您帮助儿童的精神教育吗？',
            answer: '是的，我们帮助家庭为他们的孩子找到合适的宗教教育项目和青年团体。',
          },
          confidential: {
            question: '精神支持是保密的吗？',
            answer: '绝对是。所有精神和健康支持都以完全保密和尊重的方式提供。',
          },
        },
      },
      finalCta: {
        title: '在美国找到精神平静和社区。',
        button: '预约15分钟免费咨询',
      },
    },

    // Beverage Development Consulting Page
    beverage: {
      hero: {
        title: '饮品开发咨询',
        description: '通过配方、合规和分销方面的专业指导，将您的饮品概念推向市场。',
        subtitle: '从概念到市场推出的完整饮品开发。',
        cta: '预约15分钟免费咨询',
      },
      whatWeHelp: {
        title: '我们提供的帮助',
        subtitle: '端到端饮品开发和市场进入支持。',
        services: {
          formulation: {
            title: '产品配方和食谱开发',
            description: '创建适合市场的饮品配方',
          },
          compliance: {
            title: 'FDA合规和监管指导',
            description: '导航美国食品和饮料法规',
          },
          branding: {
            title: '品牌开发和包装设计',
            description: '创建引人注目的品牌标识和包装',
          },
          manufacturing: {
            title: '制造合作伙伴协调',
            description: '联系合格的饮品制造商',
          },
          distribution: {
            title: '分销策略和渠道开发',
            description: '建立有效的分销网络',
          },
          launch: {
            title: '市场推出和进入市场策略',
            description: '成功将您的饮品推向市场',
          },
        },
      },
      howItWorks: {
        title: '工作流程',
        steps: {
          call: {
            title: '免费15分钟电话',
            description: '分享您的饮品概念和商业目标。',
          },
          plan: {
            title: '开发路线图',
            description: '我们制定全面的开发和推出计划。',
          },
          sessions: {
            title: '专家指导',
            description: '在整个开发过程中提供持续咨询。',
          },
          results: {
            title: '市场推出',
            description: '成功将您的饮品推向市场。',
          },
        },
      },
      pricing: {
        title: '简单透明的定价',
        description: '根据项目范围，饮品开发咨询从3,000美元起。',
        details: '提供从概念到推出的完整产品开发综合套餐。',
        followUp: '我们在饮品开发和市场进入的每个阶段都提供专家指导。',
        cta: '开始您的饮品项目',
      },
      whyChoose: {
        title: '为什么选择我们的饮品专业知识',
        highlights: {
          experience: '在美国饮品市场的丰富经验',
          network: '强大的制造商和分销商网络',
          compliance: 'FDA和行业法规的深度知识',
          success: '成功饮品推出的良好记录',
        },
      },
      faq: {
        title: '常见问题',
        questions: {
          timeline: {
            question: '饮品开发需要多长时间？',
            answer: '时间表因复杂性而异，通常从概念到市场推出需要6-18个月，这取决于配方和监管要求。',
          },
          minimum: {
            question: '最低生产数量是多少？',
            answer: '最低数量取决于制造商和产品类型，初始生产运行通常从500-1000箱开始。',
          },
          costs: {
            question: '涉及的总成本是多少？',
            answer: '总成本包括咨询、配方、监管、制造设置和初始生产。我们在规划期间提供详细的成本分解。',
          },
          international: {
            question: '您能帮助国际饮品概念吗？',
            answer: '是的，我们专门帮助中国企业家将传统和创新的饮品概念带到美国市场。',
          },
        },
      },
      finalCta: {
        title: '将您的饮品梦想变为现实。',
        button: '预约15分钟免费咨询',
      },
    },

    // Elite Concierge Services Page
    elite: {
      hero: {
        title: '高端管家服务',
        description: '为挑剔客户提供白手套个人助理和高端生活方式管理。',
        subtitle: '为高净值个人和家庭提供专属管家服务。',
        cta: '预约15分钟免费咨询',
      },
      whatWeHelp: {
        title: '我们提供的帮助',
        subtitle: '全方位生活方式管理和个人助理服务。',
        services: {
          travel: {
            title: '豪华旅行规划和协调',
            description: '独家旅行体验和无缝物流',
          },
          events: {
            title: '私人活动策划和准入',
            description: '独家活动准入和定制活动策划',
          },
          dining: {
            title: '高级餐厅预订和体验',
            description: '顶级餐厅和烹饪体验的准入',
          },
          personal: {
            title: '个人购物和生活方式服务',
            description: '精心策划的购物体验和个人造型',
          },
          business: {
            title: '执行助理和商业支持',
            description: '高级行政支持和商业协调',
          },
          family: {
            title: '家庭和家庭管理',
            description: '完整的家庭生活方式协调和支持',
          },
        },
      },
      howItWorks: {
        title: '工作流程',
        steps: {
          call: {
            title: '保密咨询',
            description: '讨论您的生活方式需求和服务期望。',
          },
          plan: {
            title: '个性化服务计划',
            description: '我们设计定制的管家服务套餐。',
          },
          sessions: {
            title: '专属支持',
            description: '您的专属管家团队提供持续支持。',
          },
          results: {
            title: '提升生活方式',
            description: '体验无缝的豪华生活方式管理。',
          },
        },
      },
      pricing: {
        title: '高端服务定价',
        description: '根据服务级别，高端管家服务从每年12,000-75,000美元起。',
        details: '可定制的服务套餐，从兼职助理到全职专属管家团队。',
        followUp: '所有服务都以最高的谨慎和关注细节提供。',
        cta: '探索高端服务',
      },
      whyChoose: {
        title: '为什么选择我们的高端管家',
        highlights: {
          exclusive: '独家场所、活动和体验的准入',
          discretion: '绝对的谨慎和保密',
          personalized: '高度个性化和细致的服务',
          network: '广泛的豪华服务提供商网络',
        },
      },
      faq: {
        title: '常见问题',
        questions: {
          availability: {
            question: '您的可用时间是什么？',
            answer: '紧急请求24/7可用，根据您的服务级别和偏好有专门的时间。',
          },
          services: {
            question: '包含哪些服务？',
            answer: '服务根据您的需求完全可定制，从旅行和用餐到商业支持和家庭协调。',
          },
          privacy: {
            question: '您如何确保隐私？',
            answer: '我们通过全面的保密协议和严格的隐私协议维护最高的保密标准。',
          },
          international: {
            question: '您提供国际支持吗？',
            answer: '是的，无论您在美国还是在国际旅行，我们都提供无缝支持。',
          },
        },
      },
      finalCta: {
        title: '体验生活方式管理的极致。',
        button: '预约私人咨询',
      },
    },
  },

  // Booking Page
  booking: {
    header: {
      title: '预约免费15分钟咨询',
      subtitle: '获得清晰的指导和建议——无继续义务。',
      paidSessionTitle: '预约您的会话',
      paidSessionSubtitle: '选择您的会话时长并完成付款。',
    },
    services: {
      school: '学校及家庭支持',
      legal: '法律支持协调',
      realestate: '房地产与搬迁',
      homemanagement: '家庭管理',
      spiritual: '精神健康',
      business: '商业咨询',
      beverage: '饮品开发',
      concierge: '高端管家',
      unsure: '还不确定',
    },
    form: {
      serviceSelection: {
        title: '选择您的话题',
        subtitle: '选择最接近的领域——我们会从那里指导您。',
      },
      personalInfo: {
        title: '告诉我们您的需求',
        firstName: {
          label: '姓名',
          placeholder: '请输入您的姓名',
        },
        meetingMethod: {
          label: '您希望如何会面？',
          zoom: 'Zoom',
          phone: '电话',
          wechat: '微信',
        },
        email: {
          label: '电子邮箱',
          placeholder: 'your@email.com',
        },
        phone: {
          label: '电话号码',
          placeholder: '123-456-7890',
        },
        wechatId: {
          label: '微信号',
          placeholder: '您的微信号',
        },
        message: {
          label: '留言',
          placeholder: '您想要讨论什么？',
        },
        fileUpload: {
          label: '文档上传（可选）',
          placeholder: '点击上传文件',
        },
        privacyNote: '您的信息是保密的，仅用于安排您的通话。',
      },
    },
    timeSelection: {
      title: '选择您的时间',
      subtitle: '选择一个适合您的15分钟时段。',
      stepLabel: '第2步，共2步',
      paidTitle: '选择您的时间段',
      paidSubtitle: '选择一个或多个时间段。每个时间段30分钟，150美元。',
      stepOf: '第{current}步，共{total}步',
      calendar: {
        timezoneNote: '显示的时间为您的本地时区（自动检测）',
        editTimezone: '编辑时区',
      },
      timeSlots: {
        title: '可用的15分钟时段',
      },
      appointmentSummary: {
        title: '您的预约',
        topic: '话题',
        name: '姓名',
        contact: '联系方式',
        email: '电子邮箱',
        phone: '电话',
        wechat: '微信',
        scheduledFor: '预约时间',
        meetingMethod: '会面方式',
        via: '通过',
        orderSummary: '订单摘要',
        service: '服务',
        sessions: '会话',
        total: '总计',
        scheduledSessions: '预约会话',
        thirtyMin: '30分钟',
        totalAmount: '总金额',
        totalSessions: '总会话数：',
        remove: '移除',
      },
      preferences: {
        title: '偏好设置',
        required: '必填',
        emailConfirmation: {
          label: '发送邮件确认',
          description: '通过电子邮件接收预约详情和提醒',
        },
        addToCalendar: {
          label: '自动添加到日历',
          description: '我们将为Google、Outlook和Apple日历发送日历邀请',
        },
        smsReminder: {
          label: '短信提醒',
          description: '在预约前1小时发送短信提醒',
        },
        wechatReminder: {
          label: '微信提醒',
          description: '在预约前1小时发送微信消息提醒',
        },
      },
      payment: {
        title: '完成您的付款',
        subtitle: '查看您的预约详情并完成付款。',
        bookingSummary: '预约摘要',
        selectPaymentMethod: '选择付款方式',
        paymentMethodSelected: '已选择付款方式',
        methods: {
          paypal: {
            name: 'PayPal',
            description: '使用PayPal安全支付',
            instruction: '点击下方按钮通过PayPal完成付款',
            button: '使用PayPal支付',
          },
          venmo: {
            name: 'Venmo',
            description: '通过Venmo应用发送',
            instruction: '使用Venmo扫描二维码：',
            placeholder: '[Venmo二维码]',
          },
          wechat: {
            name: '微信支付',
            description: '扫码支付',
            instruction: '使用微信扫描二维码：',
            placeholder: '[微信支付二维码]',
          },
          alipay: {
            name: '支付宝',
            description: '扫码支付',
            instruction: '使用支付宝扫描二维码：',
            placeholder: '[支付宝二维码]',
          },
        },
        paymentNote: {
          title: '注意：',
          message: '付款后您的预约将立即确认。您将收到包含会议详情的确认邮件。',
        },
        confirmationNote: '收到付款后将确认您的预约',
      },
    },
    buttons: {
      continue: '继续选择时间 →',
      confirm: '确认并预约 →',
      back: '← 返回详情',
      returnHome: '返回首页',
      exploreServices: '探索服务 →',
      continueToPayment: '继续付款 →',
      finalizeBooking: '确认预约 →',
      backToTimeSelection: '← 返回时间选择',
      creatingAppointment: '正在创建预约...',
    },
    confirmationNote: '确认邮件将立即发送。',
    errorMessages: {
      selectDateTime: '请选择预约的日期和时间。',
      submitError: '发生意外错误，请重试。',
    },
    monthNames: {
      january: '一月',
      february: '二月',
      march: '三月',
      april: '四月',
      may: '五月',
      june: '六月',
      july: '七月',
      august: '八月',
      september: '九月',
      october: '十月',
      november: '十一月',
      december: '十二月',
    },
    successModal: {
      title: '谢谢您 - 全部设置完成！',
      zoom: {
        message: '带有Zoom链接的确认邮件正在发送到{email}。我们期待与您在线会面。',
        messageWithPayment: '您的付款已收到，您的咨询已确认。带有Zoom链接的确认邮件正在发送到{email}。我们期待与您在线会面。',
      },
      phone: {
        message: '已发送确认信息。我们将在预定时间拨打{phone}。我们期待与您通话。',
        messageWithPayment: '您的付款已收到，您的咨询已确认。已发送确认信息。我们将在预定时间拨打{phone}。我们期待与您通话。',
      },
      wechat: {
        message: '我们将通过微信{wechatId}联系您。我们期待与您联系。',
        messageWithPayment: '您的付款已收到，您的咨询已确认。我们将通过微信{wechatId}联系您。我们期待与您联系。',
      },
    },
    phoneCountries: {
      us: '+1 (美国/加拿大)',
      cn: '+86 (中国)',
      hk: '+852 (香港)',
      mo: '+853 (澳门)',
      tw: '+886 (台湾)',
      sg: '+65 (新加坡)',
      uk: '+44 (英国)',
    },
    dayNames: {
      sun: '周日',
      mon: '周一',
      tue: '周二',
      wed: '周三',
      thu: '周四',
      fri: '周五',
      sat: '周六',
    },
  },

  // Common/Shared
  common: {
    loading: '加载中...',
    error: '发生错误',
    retry: '重试',
    close: '关闭',
    next: '下一个',
    previous: '上一个',
    save: '保存',
    cancel: '取消',
  },
};
